/* eslint-disable @typescript-eslint/explicit-function-return-type */

import { ConvocatoriasState } from '.'

/**
 * Set default city when cities length equal to 1
 */
export function setDefaultCity() {
  if (ConvocatoriasState.cities.value.length === 1) {
    ConvocatoriasState.currentCity.value = ConvocatoriasState.cities.value[0]
      .value as string
  } else {
    ConvocatoriasState.currentCity.value = null
  }
}
